import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
const StyledModalContainer = styled('div', {
    shouldForwardProp: (prop)=>![
            'lgWidth',
            'mdWidth'
        ].includes(prop.toString())
})(({ lgWidth, mdWidth, theme })=>({
        '& > form': {
            display: 'contents'
        },
        /** WCAG 1.4.10 */ '@media (max-height: 500px)': {
            overflowY: 'auto'
        },
        backgroundColor: theme.palette.common.white,
        borderRadius: '0.75rem',
        display: 'flex',
        flexDirection: 'column',
        margin: theme.spacing(1),
        maxHeight: 'calc(100% - 1rem)',
        outline: 'none',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            width: mdWidth ?? '44rem'
        },
        [theme.breakpoints.down('sm')]: {
            height: '100%',
            margin: 0,
            width: '100%'
        },
        width: lgWidth ?? '44rem'
    }));
export const ModalContainer = (props)=>/*#__PURE__*/ _jsx(StyledModalContainer, {
        ...props,
        children: props.children
    });
ModalContainer.displayName = 'ModalContainer';

//# sourceMappingURL=ModalContainer.js.map